var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.104,
    height: 15.103,
    viewBox: "0 0 15.104 15.103",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_178",
    "data-name": "Group 178",
    transform: "translate(-1.5 -1.424)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_367",
    "data-name": "Path 367",
    d: "M11.094,2.5a1.752,1.752,0,0,1,2.383,0l3.855,3.855a1.752,1.752,0,0,1,0,2.383l-2.593,2.593a1.752,1.752,0,0,1-2.383,0L8.5,7.477a1.752,1.752,0,0,1,0-2.383Z",
    transform: "translate(-1.805)",
    fill: "none",
    stroke: "#40aeee",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_368",
    "data-name": "Path 368",
    d: "M14,7l2.1,2.1",
    transform: "translate(-3.59 -1.486)",
    fill: "none",
    stroke: "#40aeee",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_369",
    "data-name": "Path 369",
    d: "M7.186,10.6,2.411,15.376A1.4,1.4,0,0,0,2,16.367v1.522a.7.7,0,0,0,.7.7H4.8a.7.7,0,0,0,.7-.7v-.7a.7.7,0,0,1,.7-.7h.7a.7.7,0,0,0,.7-.7v-.7a.7.7,0,0,1,.7-.7h.121a1.4,1.4,0,0,0,.991-.41L9.99,13.4",
    transform: "translate(0 -2.563)",
    fill: "none",
    stroke: "#40aeee",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.9c795b44c57d4aafcdafceeb4a5c7d4b.svg";
export { ForwardRef as ReactComponent };